import { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Login } from "@/pages/Login";
import { ChartPage } from "@/pages/ChartPage";

export default function App() {
  const { hydrate } = useAuth();

  // On mount, try silent refresh + fetch /me. If both fail, user lands on /login.
  useEffect(() => {
    hydrate();
  }, [hydrate]);

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/chart"
        element={
          <ProtectedRoute>
            <ChartPage />
          </ProtectedRoute>
        }
      />
      <Route path="/" element={<Navigate to="/chart" replace />} />
      <Route path="*" element={<Navigate to="/chart" replace />} />
    </Routes>
  );
}
